import {
  Box,

  TextField,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from "@mui/material";
import ButtonComp from "../../../components/Button";
import { useState } from "react";

export default function ClaimStatus(props: any) {
  const { handleSubmit, handleInputChange, inputValue, idType, handleToggle } =
    props;
  const theme = useTheme();
  const [errorMessage, setErrorMessage] = useState("");
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "50vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box width={{xs:350,sm:560}}>
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {/* Toggle Buttons */}
            <ToggleButtonGroup
              exclusive
              value={idType}
              onChange={(_, newType) => handleToggle(newType)}
              sx={{
                border: "2px solid ${theme.palette.primary.main}",
                height: "36px",
                alignSelf: "center",
              }}
            >
              <ToggleButton
                value="policy"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  fontFamily: theme.typography.fontFamily,
                  px: 3,
                  py: 1.5,
                  borderRadius: "2px",
                  color:
                    idType === "policy"
                      ? `${theme.palette.primary.contrastText}!important`
                      : theme.palette.text.primary,
                  backgroundColor:
                    idType === "policy"?
                        "#EC6E00 !important"
                      : "",

                  "&:hover": {
                    bgcolor:
                      idType === "policy"
                        ? theme.palette.secondary.main
                        : theme.palette.background.paper,
                  },
                }}
              >
                Policy Id
              </ToggleButton>
              <ToggleButton
                value="claim"
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  fontFamily: theme.typography.fontFamily,
                  px: 3,
                  py: 1.5,
                  borderRadius: "2px",
                  color:
                    idType === "claim"
                      ? `${theme.palette.primary.contrastText}!important`
                      : theme.palette.text.primary,

                  bgcolor:
                    idType === "claim"?
                        "#EC6E00 !important"
                      : "transparent",

                  "&:hover": {
                    bgcolor:
                      idType === "claim"
                        ? theme.palette.secondary.main
                        : theme.palette.background.paper,
                  },
                }}
              >
                Claim No.
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
          <Box
            mt={5}
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            gap={0.5}
          >
            <TextField
              fullWidth
              placeholder="Enter ID"
              variant="outlined"
              size="medium"
              value={inputValue}
              onChange={(e) => {
                handleInputChange(e);
                setErrorMessage("");
              }}
              error={Boolean(errorMessage)}
              helperText={errorMessage}
            />
          </Box>
          <Box mt={3}>
            <ButtonComp
              height={40}
              width={190}
              variant="contained"
              onClick={() => {
                const trimmedValue = inputValue.trim();

                if (!trimmedValue) {
                  setErrorMessage(
                    `Please enter a ${
                      idType === "claim" ? "Claim" : "Policy"
                    } ID`
                  );
                  return;
                }
                // All validations passed
                setErrorMessage("");
                handleSubmit();
              }}
            >
              OK
            </ButtonComp>
          </Box>
        </Box>
      </Box>
    </>
  );
}
